import React from 'react';

export const UpdateProjectNicknamesActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} {props.CustomEventData.action} the Nickname
    "{props.CustomEventData ? props.CustomEventData.value : ""}".
</p>;


